import type { Action, WidgetState } from './types';

export const reducer = (state: WidgetState, action: Action): WidgetState => {
    switch (action.type) {
        case 'SET_IS_KLARNA_BUTTON_DISPLAYED':
            return {
                ...state,
                isKlarnaButtonDisplayed: action.payload ?? false,
            };
        case 'SET_IS_KLARNA_BUTTON_AVAILABLE':
            return {
                ...state,
                isKlarnaButtonAvailable: action.payload,
            };
        case 'SET_IS_PAYPAL_BUTTON_DISPLAYED':
            return {
                ...state,
                isPaypalButtonDisplayed: action.payload,
            };
        case 'SET_IS_APPLE_PAY_BUTTON_DISPLAYED':
            return {
                ...state,
                isApplePayButtonDisplayed: action.payload,
            };
        case 'SET_IS_ANY_BUTTON_READY':
            return {
                ...state,
                isAnyButtonReady: action.payload ?? false,
            };
        case 'SET_ACTIVE_BASKET_SUMMARY':
            return {
                ...state,
                activeBasketSummary: action.payload,
            };

        default: {
            const unhandledAction: never = action;
            throw new Error(`The action '${(unhandledAction as { type: string }).type}' is not handled by the reducer.`);
        }
    }
};
